export const TESTS_URL = '/tests';
export const GT_IDS_URL = '/gt_ids';
